import dayjs from "dayjs";
import { createSelector } from "@reduxjs/toolkit";

export const NEW_BOOKING = "NEW_BOOKING";
export const FETCH_BOOK_NOW_DETAILS = "FETCH_BOOK_NOW_DETAILS";
export const SET_BOOK_NOW_DETAILS = "SET_BOOK_NOW_DETAILS";
export const RESET_BOOK_NOW_DETAILS = "RESET_BOOK_NOW_DETAILS";
export const SET_NEW_BOOKING_DATA = "SET_NEW_BOOKING_DATA";
export const VERIFY_PAYMENT = "VERIFY_PAYMENT";
export const MAKE_SLOT_AVAILABLE = "MAKE_SLOT_AVAILABLE";
export const CHECK_HOLIDAY_BOOKING = "CHECK_HOLIDAY_BOOKING";
export const SET_HOLIDAY_BOOKING_STATUS = "SET_HOLIDAY_BOOKING_STATUS";
export const FETCH_HOLIDAY_DATES = "FETCH_HOLIDAY_DATES";
export const SET_HOLIDAY_DATES = "SET_HOLIDAY_DATES";
export const FETCH_SPECIAL_SCHEDULE_DATES = "FETCH_SPECIAL_SCHEDULE_DATES";
export const SET_SPECIAL_SCHEDULE_DATES = "SET_SPECIAL_SCHEDULE_DATES";
export const UPDATE_SPECIAL_SCHEDULE = "UPDATE_SPECIAL_SCHEDULE";
export const SET_BOOK_NOW_DATE = "SET_BOOK_NOW_DATE";
export const CHECK_DATE_PRESENCE = "CHECK_DATE_PRESENCE";
export const SET_DATE_PRESENCE_STATUS = "SET_DATE_PRESENCE_STATUS";
export const FETCH_DAY_MAPPINGS = "FETCH_DAY_MAPPINGS";
export const SET_DAY_MAPPINGS = "SET_DAY_MAPPINGS";
export const FETCH_PRICING_CONFIGS = "FETCH_PRICING_CONFIGS";
export const SET_PRICING_CONFIGS = "SET_PRICING_CONFIGS";
export const SET_AVAILABLE_SLOTS = "SET_AVAILABLE_SLOTS";
export const SET_EQUIPMENT_CONFIGS = "SET_EQUIPMENT_CONFIGS";

export const fetchBookNowDetail = ({ date, sport, location } = {}) => ({
  type: FETCH_BOOK_NOW_DETAILS,
  payload: { date, sport, location },
});

export const newBooking = ({
  sport,
  emailAddress,
  slotDate,
  slotTime,
  duration,
  turfNumber,
  paidAmount,
  totalAmount,
  location,
  equipment_selections,
}) => {
  return {
    type: NEW_BOOKING,
    payload: {
      sport,
      emailAddress,
      slotDate,
      slotTime,
      duration,
      turfNumber,
      paidAmount,
      totalAmount,
      location,
      equipment_selections,
    },
  };
};
export const makeSlotAvailable = ({
  slotDate,
  slotTime,
  turfNumber,
  sport,
  location,
  duration,
}) => ({
  type: MAKE_SLOT_AVAILABLE,
  payload: {
    slotDate,
    slotTime,
    turfNumber,
    sport,
    location,
    duration,
  },
});

export const verifyPayment = ({
  razorpay_order_id,
  razorpay_payment_id,
  razorpay_signature,
  transactionId,
  sport,
  turfNumber,
  slotDate,
  slotTime,
  duration,
  paidAmount,
  totalAmount,
  location,
}) => ({
  type: VERIFY_PAYMENT,
  payload: {
    razorpay_order_id,
    razorpay_payment_id,
    razorpay_signature,
    transactionId,
    sport,
    turfNumber,
    slotDate,
    slotTime,
    duration,
    paidAmount,
    totalAmount,
    location,
  },
});

export const setBookNowDetail = (data) => ({
  type: SET_BOOK_NOW_DETAILS,
  payload: { data },
});

export const setNewBookingData = (data) => ({
  type: SET_NEW_BOOKING_DATA,
  payload: { data },
});

export const resetBookNowDetail = () => ({
  type: RESET_BOOK_NOW_DETAILS,
});

export const checkHolidayBooking = ({ date, sport, location } = {}) => ({
  type: CHECK_HOLIDAY_BOOKING,
  payload: { date, sport, location },
});

export const setHolidayBookingStatus = (status) => ({
  type: SET_HOLIDAY_BOOKING_STATUS,
  payload: { status },
});

export const fetchHolidayDates = ({ sport, location } = {}) => ({
  type: FETCH_HOLIDAY_DATES,
  payload: { sport, location },
});

export const setHolidayDates = (dates) => ({
  type: SET_HOLIDAY_DATES,
  payload: { dates },
});

export const fetchSpecialScheduleDates = ({ sport, location } = {}) => ({
  type: FETCH_SPECIAL_SCHEDULE_DATES,
  payload: { sport, location },
});

export const setSpecialScheduleDates = (dates) => ({
  type: SET_SPECIAL_SCHEDULE_DATES,
  payload: { dates },
});

export const updateSpecialSchedule = ({ sport, location, dates } = {}) => ({
  type: UPDATE_SPECIAL_SCHEDULE,
  payload: { sport, location, dates },
});

export const setBookNowDate = (date) => ({
  type: SET_BOOK_NOW_DATE,
  payload: { date },
});

export const checkDatePresence = ({ date, sport, location } = {}) => ({
  type: CHECK_DATE_PRESENCE,
  payload: { date, sport, location },
});

export const setDatePresenceStatus = (status) => ({
  type: SET_DATE_PRESENCE_STATUS,
  payload: { status },
});

export const fetchDayMappings = ({ location } = {}) => ({
  type: FETCH_DAY_MAPPINGS,
  payload: { location },
});

export const setDayMappings = (dayMappings) => ({
  type: SET_DAY_MAPPINGS,
  payload: { dayMappings },
});

export const fetchPricingConfigs = ({ sport, location, date } = {}) => ({
  type: FETCH_PRICING_CONFIGS,
  payload: { sport, location, date },
});

export const setPricingConfigs = (pricingConfigs) => ({
  type: SET_PRICING_CONFIGS,
  payload: { pricingConfigs },
});

export const setAvailableSlots = (availableSlots) => ({
  type: SET_AVAILABLE_SLOTS,
  payload: { availableSlots },
});

export const setEquipmentConfigs = (equipmentConfigs) => ({
  type: SET_EQUIPMENT_CONFIGS,
  payload: { equipmentConfigs },
});

const initialState = {
  date: dayjs().format("YYYY-MM-DD"), // Store date as string instead of Day.js object
  bookingAllowed: true, // If client has blocked booking of any turf this would be true otherwise false
  slotsAvailability: { turfA: [], turfB: [], turfC: [] },
  slots: { turfA: [], turfB: [], turfC: [] },
  newBooking: { order_id: "", transactionId: "", currency: "", amount: "" },
  holidayBookingStatus: null, // Holiday booking check status
  holidayDates: [], // Holiday dates for the selected sport and location
  specialScheduleDates: [], // Special schedule dates for the selected sport and location
  datePresenceStatus: null, // Date presence check status
  dayMappings: null, // Day mappings configuration
  pricingConfigs: null, // Pricing configurations
  availableSlots: null, // Available slots data
  equipmentConfigs: [], // Equipment configurations for Pickle Ball
};

const bookNow = (state = initialState, action) => {
  if (action.type === SET_BOOK_NOW_DETAILS) {
    const data = action.payload.data;
    // Ensure date is stored as string
    if (data.date && data.date.format) {
      data.date = data.date.format("YYYY-MM-DD");
    }
    return { ...state, ...data };
  }
  if (action.type === SET_BOOK_NOW_DATE) {
    return {
      ...state,
      date: action.payload.date,
    };
  }
  if (action.type === SET_NEW_BOOKING_DATA) {
    return {
      ...state,
      newBooking: { ...action.payload.data },
    };
  }
  if (action.type === SET_HOLIDAY_BOOKING_STATUS) {
    return {
      ...state,
      holidayBookingStatus: action.payload.status,
    };
  }
  if (action.type === SET_HOLIDAY_DATES) {
    return {
      ...state,
      holidayDates: action.payload.dates,
    };
  }
  if (action.type === SET_SPECIAL_SCHEDULE_DATES) {
    return {
      ...state,
      specialScheduleDates: action.payload.dates,
    };
  }

  if (action.type === SET_DATE_PRESENCE_STATUS) {
    return {
      ...state,
      datePresenceStatus: action.payload.status,
    };
  }

  if (action.type === SET_DAY_MAPPINGS) {
    return {
      ...state,
      dayMappings: action.payload.dayMappings,
    };
  }

  if (action.type === SET_PRICING_CONFIGS) {
    return {
      ...state,
      pricingConfigs: action.payload.pricingConfigs,
    };
  }

  if (action.type === SET_AVAILABLE_SLOTS) {
    return {
      ...state,
      availableSlots: action.payload.availableSlots,
    };
  }

  if (action.type === SET_EQUIPMENT_CONFIGS) {
    return {
      ...state,
      equipmentConfigs: action.payload.equipmentConfigs,
    };
  }

  if (action.type === RESET_BOOK_NOW_DETAILS) {
    return initialState;
  }
  return state;
};

export default bookNow;

export const getBookNowData = ({ bookNow }) => bookNow;

// Memoized selector that converts date string back to Day.js object for components
export const getBookNowDataWithDateObject = createSelector(
  [getBookNowData],
  (bookNow) => ({
    ...bookNow,
    date: dayjs(bookNow.date),
  })
);
